export const availableDmPlayerProfiles = {
  synopsis: "xayeu",
  dvdItem: "xayew",
  sliderItem: "xayev",
  playerFooter: "xayet",
};
